import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LoadApp from './LoadApp';
import CustomClosePopup from './components/CustomClosePopup';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_ROOT_PATH}>
      <LoadApp />
      <CustomClosePopup />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
